import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import api from '../api/api';

const SchoolApplication: React.FC = () => {
  const [schoolName, setSchoolName] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setError('');
    try {
      await api.post('/schools/apply', {
        school_name: schoolName,
        contact_name: contactName,
        contact_email: contactEmail,
        contact_phone: contactPhone,
        message,
      });
      setStatus('success');
    } catch (err: any) {
      setStatus('error');
      setError(err?.response?.data?.detail || 'Failed to submit application.');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', p: 2 }}>
      <Paper elevation={8} sx={{ p: 4, borderRadius: 3, minWidth: 350, maxWidth: 400, textAlign: 'center' }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>School Application</Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Interested in using our platform? Fill out this form and our team will review your application.
        </Typography>
        {status === 'success' ? (
          <Alert severity="success" sx={{ mt: 2 }}>
            Thank you for your interest! Your application has been received. We will contact you soon.
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              label="School Name"
              value={schoolName}
              onChange={e => setSchoolName(e.target.value)}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Contact Name"
              value={contactName}
              onChange={e => setContactName(e.target.value)}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Contact Email"
              type="email"
              value={contactEmail}
              onChange={e => setContactEmail(e.target.value)}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Contact Phone"
              value={contactPhone}
              onChange={e => setContactPhone(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Message (optional)"
              value={message}
              onChange={e => setMessage(e.target.value)}
              fullWidth
              margin="normal"
              multiline
              minRows={3}
            />
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2, py: 1.2, fontWeight: 600, borderRadius: 2 }}
              disabled={status === 'loading'}
            >
              {status === 'loading' ? <CircularProgress size={22} /> : 'Submit Application'}
            </Button>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default SchoolApplication; 